import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Spinner } from "reactstrap";
import useOrderOverview from "./graph/useOrderOverview";

/**
 * Doce barras a 390px quedan a 24px cada una, ilegibles: en móvil el rango
 * arranca en seis. El recorte lo hace `useOrderOverview` sobre lo que ya
 * trajo el endpoint, así que cambiar de rango no dispara otra consulta.
 */
const isNarrow = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 991.98px)").matches;

const SalesGrowthChart = ({ selectedCountry }) => {
    const [groupBy, setGroupBy] = useState("month");
    const [range, setRange] = useState(() => (isNarrow() ? 6 : 12));

    const {
        chartConfig,
        isLoading,
        error
    } = useOrderOverview(selectedCountry, groupBy, range);

    return (
        <div className="ui-card">

            <div className="ui-card__head">
                <div>
                    <h2 className="ui-card__title">Crecimiento de ventas</h2>
                    <div className="ui-card__sub">
                        {groupBy === "month"
                            ? `Últimos ${range} meses`
                            : `Últimos ${range} días`}
                    </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                    <div className="ui-legend d-none d-md-flex">
                        <span><i style={{ background: "#4B36F0" }} /> Ventas netas</span>
                    </div>

                    <span className="ui-filter-select">
                        <select
                            value={range}
                            onChange={(e) => setRange(Number(e.target.value))}
                            aria-label="Rango"
                        >
                            <option value={6}>6</option>
                            <option value={12}>12</option>
                        </select>
                    </span>

                    <span className="ui-filter-select">
                        <select
                            value={groupBy}
                            onChange={(e) => setGroupBy(e.target.value)}
                            disabled={isLoading}
                            aria-label="Agrupación"
                        >
                            <option value="month">Mensual</option>
                            <option value="day">Diario</option>
                        </select>
                    </span>
                </div>
            </div>

            {error ? (
                <div className="ui-note ui-note--danger">
                    No se pudo cargar el crecimiento de ventas.
                </div>
            ) : isLoading ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: 260 }}
                >
                    <Spinner color="primary" />
                </div>
            ) : (
                <ReactApexChart
                    options={chartConfig.options}
                    series={chartConfig.series}
                    type="bar"
                    height={260}
                />
            )}

        </div>
    );
};

export default SalesGrowthChart;
